import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GridUtilsModule } from 'app/core/modules/grid-utils.module';

@Component({
  selector: 'app-adobe-callback',
  standalone: true,
  imports: [GridUtilsModule],
  template: `<div>{{ 'confirmMessages.processingAdobeToken' | translate }}</div>`,
})
export class AdobeCallbackComponent implements OnInit {
  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const code = params['code'];
      const state = params['state'];

      if (code && state && window.opener) {
        window.opener.postMessage(
          {
            type: 'adobe-oauth-code',
            code,
            state,
          },
          window.location.origin
        );
      }
    });
  }
}
